<div class="modal-header">
    <span *ngIf="!validatorId" class="modal-header-title">{{ 'DIALOG.ATTRIBUTE.CREATE_VALIDATOR_ATTRIBUTE' | translate }}</span>
    <span *ngIf="validatorId"  class="modal-header-title">{{ 'DIALOG.ATTRIBUTE.EDITE_VALIDATOR_ATTRIBUTE' | translate }}</span>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>

<div class="modal-body">

    <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">
        <div class="row">
            <div class="col-12">
                <ff-input-lang label="{{ 'DIALOG.GROUPS.ADD_GROUPS' | translate }}" hint="{{ 'DIALOG.ATTRIBUTE.NAME_VALIDATOR_ALL_LANGUAGE' | translate }}" fieldId="name"
                    fieldName="name" fieldType="text" [clearField]="ffInputLangParams.name.clearField"
                    [required]="ffInputLangParams.name.required" [inputValue]="validatorName"
                    (changeValue)="eventFnFF('name', $event.name)">
                </ff-input-lang>
            </div>
        </div>
    </form>


    <div class="filter">

        <div class="row operator-block">

            <div class="col-6 form">
                <div class="form-group">
                    <label class="filter-label" for="legal_form_id">{{ 'CONDITIONS_FILTER.BOOLEAN_OPERATOR' | translate }}:</label>
                    <ng-select id="attribute_id" class="custom" notFoundText="{{ 'NO_DATA' | translate }}" bindLabel="name"
                        bindValue="id" [multiple]="false" [items]="operatorsForCondition"
                        [(ngModel)]="selectedOperatorsForCondition" [clearable]="false" appendTo="body">
                    </ng-select>
                </div>
            </div>

            <div class="col-6 filter-buttons">
                <button type="button" class="btn btn-primary btn-sm" (click)="addFilterFields()">
                     <i class="bi bi-plus-circle"></i> {{ 'CONDITIONS_FILTER.ADD_FILTER' | translate }}
                </button>

                <!-- <button class="btn btn-outline btn-sm" (click)="resetFilter()"> Сбросить</button> -->
            </div>

        </div>

        <div class="row">
            <div class="col-12 filter-fields">

                <form class="form" #cf="ngForm" [formGroup]="conditionForm" autocomplete="off">
form
                    <div formArrayName="filters">

                        <div *ngFor="let item of conditionForm.get('filters')['controls']; let i = index;">

                            <div class="row" [formGroupName]="i">

                                <div class="col-4">
                                    <div class="form-group">
                                        <label class="filter-label" for="attribute_id"> {{ 'ATTRIBUTE' | translate }}:</label>
                                        <ng-select id="attribute_id" class="custom" clearAllText="{{ 'CLEAR' | translate }}"
                                            notFoundText="{{ 'NO_DATA' | translate }}" bindLabel="name" bindValue="id"
                                            formControlName="attribute_id" [multiple]="false" [items]="attributes"
                                            appendTo="body">
                                        </ng-select>
                                        <div *ngIf="errorMessages">
                                            <div *ngFor="let item of errorMessages.attribute_id">
                                                <div class="text-error" *ngIf="validation(['filters', i, 'attribute_id'], item.type)">
                                                    {{ item.message | translate: item.options }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-3">
                                    <div class="form-group">
                                        <label class="filter-label" for="operator"> {{ 'CONDITIONS_FILTER.OPERATOR' | translate }}:</label>
                                        <ng-select id="attribute_id" class="custom" notFoundText="{{ 'NO_DATA' | translate }}"
                                            bindLabel="name" bindValue="id" formControlName="operator"
                                            [multiple]="false" [clearable]="false" [items]="operators" appendTo="body">
                                        </ng-select>
                                        <div *ngIf="errorMessages">
                                            <div *ngFor="let item of errorMessages.operator">
                                                <div class="text-error" *ngIf="validation(['filters', i, 'operator'], item.type)">
                                                    {{ item.message | translate: item.options }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-4">
                                    <div class="form-group">
                                        <label class="filter-label" for="value"> {{ 'VALUE' | translate }}:</label>
                                        <tag-input formControlName="value" placeholder="{{ 'ADD_VALUE' | translate }}"
                                            secondaryPlaceholder="{{ 'INTER_VALUE' | translate }}" addOnBlur="true" [modelAsStrings]="true"></tag-input>
                                        <div *ngIf="errorMessages">
                                            <div *ngFor="let item of errorMessages.value">
                                                <div class="text-error" *ngIf="validation(['filters', i, 'value'], item.type)">
                                                     {{ item.message | translate: item.options }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-1 remove-filter-field"
                                    *ngIf="conditionForm.get('filters').value.length > 1">
                                    <button type="button" class="btn btn-danger" (click)="removeAddressField(i)">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

</div>
<div class="modal-footer btn-box">
    <button *ngIf="!validatorId" type="button" class="btn btn-primary btn-sm" (click)="onCreate()"
        [disabled]="form.invalid || conditionForm.invalid">{{ 'SAVE'| translate}}</button>
    <button *ngIf="validatorId" type="button" class="btn btn-primary btn-sm" (click)="onUpdate()"
        [disabled]="form.invalid || conditionForm.invalid">{{ 'SAVE'| translate}}</button>
    <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss(false)">
        {{ 'CLOSE' | translate}}
    </button>
</div>